module.exports = __webpack_public_path__ + "img/5.ef1e1882.svg";